function setCookie(name, value, hoursToExpire) {
  const now = new Date(),
    expiration = new Date(now.getTime() + hoursToExpire * 60 * 60 * 1e3);
  document.cookie = `${name}=${value}; expires=${expiration.toUTCString()}; path=/`;
}
function getCookie(cookieName) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookieParts = cookies[i].trim().split("=");
    if (cookieParts[0] === cookieName) return cookieParts[1];
  }
  return null;
}
function checkCookie(cookieName) {
  return getCookie(cookieName) !== null;
}
//# sourceMappingURL=/cdn/shop/t/135/assets/cookie-management.js.map?v=180761083481196546071732699292
